import color from "../../constants/color";

const style = {
  container: {
    backgroundColor: color.lightGray,
    borderRadius: "24px",
    padding: "20px",
    margin: "12px",
    minHeight: "280px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  header: {
    fontSize: "22px",
    fontWeight: 600,
    color: color.text,
  },
  cardsWrapper: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "16px",
  },
  card: {
    backgroundColor: color.card,
    borderRadius: "20px",
    padding: "16px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    boxShadow: "0px 12px 40px rgba(0, 0, 0, 0.06)",
  },
  cardTitle: {
    fontSize: "24px",
    fontWeight: 600,
    color: color.text,
    textAlign: "center",
  },
  fieldLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.text,
    marginBottom: "4px",
  },
  input: {
    maxWidth: "280px",
  },
  helperRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "-8px",
  },
  helperText: {
    fontSize: "14px",
    color: color.lightText,
  },
  primaryButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "18px",
    width: "120px",
    alignSelf: "flex-end",
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "none",
    marginTop: "8px",
    "&:hover": {
      backgroundColor: "#189039",
    },
    "&.Mui-disabled": {
      backgroundColor: "#A5A5A5",
      color: "#fff",
    },
  },
  loadingState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "220px",
  },
};

export default style;

